"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedVersion = exports.selectVersion = exports.loadVersions = exports.clearingSelectedVersion = exports.selectingVersion = exports.doneLoadingVersions = exports.receivedVersions = exports.nowLoadingVersions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _actiontypes = _interopRequireDefault(require("./actiontypes"));

var _actionhelpers = require("./actionhelpers");

/* Basic Actions */
var nowLoadingVersions = function nowLoadingVersions() {
  return {
    type: _actiontypes["default"].NOW_LOADING_VERSIONS
  };
};

exports.nowLoadingVersions = nowLoadingVersions;

var receivedVersions = function receivedVersions(_ref) {
  var availableVersions = _ref.availableVersions;
  return {
    type: _actiontypes["default"].RECEIVED_VERSIONS,
    availableVersions: availableVersions
  };
};

exports.receivedVersions = receivedVersions;

var doneLoadingVersions = function doneLoadingVersions() {
  return {
    type: _actiontypes["default"].DONE_LOADING_VERSIONS
  };
};

exports.doneLoadingVersions = doneLoadingVersions;

var selectingVersion = function selectingVersion(selectedVersion) {
  return {
    type: _actiontypes["default"].SELECTING_VERSION,
    selectedVersion: selectedVersion
  };
};

exports.selectingVersion = selectingVersion;

var clearingSelectedVersion = function clearingSelectedVersion() {
  return {
    type: _actiontypes["default"].CLEARING_SELECTED_VERSION
  };
};
/* Advanced/Thunk Actions */

/**
 * Populates the list of versions
 * @param {string} accessToken Used to authenticate the user
 * @param {string} fulfillmentConfigurationId The id of the FC to load the versions of
 */


exports.clearingSelectedVersion = clearingSelectedVersion;

var loadVersions = function loadVersions(_ref2) {
  var accessToken = _ref2.accessToken,
      fulfillmentConfigurationId = _ref2.fulfillmentConfigurationId;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var _getState, environment, availableVersions;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _getState = getState(), environment = _getState.componentShellReducer.environment;
              dispatch(nowLoadingVersions());
              _context.next = 5;
              return (0, _actionhelpers.getVersionsList)({
                accessToken: accessToken,
                fulfillmentConfigurationId: fulfillmentConfigurationId,
                environment: environment
              });

            case 5:
              availableVersions = _context.sent;
              dispatch(receivedVersions({
                availableVersions: availableVersions
              }));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.log(_context.t0);

            case 12:
              _context.prev = 12;
              dispatch(doneLoadingVersions());
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9, 12, 15]]);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * Selects a FC version
 * @param {string} versionId The id of the version to select
 * @param {string} versionNumber The human readable id of the version to select. Not unique.
 */


exports.loadVersions = loadVersions;

var selectVersion = function selectVersion(_ref4) {
  var versionId = _ref4.versionId,
      versionNumber = _ref4.versionNumber;
  return function (dispatch) {
    dispatch(selectingVersion({
      versionId: versionId,
      versionNumber: versionNumber
    }));
  };
};
/**
 * Clears out the selected FC version
 */


exports.selectVersion = selectVersion;

var clearSelectedVersion = function clearSelectedVersion() {
  return function (dispatch) {
    dispatch(clearingSelectedVersion());
  };
};

exports.clearSelectedVersion = clearSelectedVersion;